/**
 * Klickbarer Link-Text (inline, z. B. in Paragraphen).
 * Wie auf Login für Datenschutz/Nutzungsbedingungen: color=theme.color.link (oder weglassen = Theme-Default).
 */
import { useTheme } from "@/theme/ThemeProvider";
import { Text, TextStyle } from "react-native";

type Props = {
  onPress: () => void;
  children: string;
  color?: string;
  style?: TextStyle;
};

export function LinkText({ onPress, children, color, style }: Props) {
  const { theme } = useTheme();

  return (
    <Text
      onPress={onPress}
      style={[
        {
          color: color ?? theme.color.link,
          fontWeight: "800",
          fontSize: theme.fontSize.small,
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}
